export default __webpack_public_path__ + "static/media/space.c9a5a2b0.png";